import { render, staticRenderFns } from "./SupportMaterialTab.vue?vue&type=template&id=df65ee60&scoped=true&"
import script from "./SupportMaterialTab.vue?vue&type=script&lang=js&"
export * from "./SupportMaterialTab.vue?vue&type=script&lang=js&"
import style0 from "./SupportMaterialTab.vue?vue&type=style&index=0&id=df65ee60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df65ee60",
  null
  
)

component.options.__file = "SupportMaterialTab.vue"
export default component.exports